/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AnswerQuestionRequest } from '../model';
// @ts-ignore
import type { EUAIActSettings } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { QuestionnaireExistsResponse } from '../model';
// @ts-ignore
import type { QuestionnaireResponse } from '../model';
// @ts-ignore
import type { QuestionnaireStepResponse } from '../model';
// @ts-ignore
import type { ScopePreview } from '../model';
// @ts-ignore
import type { UpdateEUAIActSettings } from '../model';
// @ts-ignore
import type { UpdateQuestionnaireStatusRequest } from '../model';
/**
 * EuAiActApi - axios parameter creator
 */
export const EuAiActApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Answer a question of this project\'s questionnaire and get the next step.  Answering a question again drops the answers given after it.
         * @summary Answer Question
         * @param {string} questionId 
         * @param {string} projectId 
         * @param {AnswerQuestionRequest} answerQuestionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerQuestion: async (questionId: string, projectId: string, answerQuestionRequest: AnswerQuestionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('answerQuestion', 'questionId', questionId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('answerQuestion', 'projectId', projectId)
            // verify required parameter 'answerQuestionRequest' is not null or undefined
            assertParamExists('answerQuestion', 'answerQuestionRequest', answerQuestionRequest)
            const localVarPath = `/projects/{project_id}/eu-ai-act/questionnaire/questions/{question_id}/answer`
                .replace('{question_id}', encodeURIComponent(String(questionId)))
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(answerQuestionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Whether the project has a scoping questionnaire.  The cheap availability check behind the questionnaire button; it does not load the questionnaire.
         * @summary Check Questionnaire
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkQuestionnaire: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('checkQuestionnaire', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/eu-ai-act/questionnaire/exists`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Save the EU AI Act answers for the AI System, replacing any stored ones. Does not apply the scope.
         * @summary Create Eu Ai Act Settings For Project
         * @param {string} projectId 
         * @param {UpdateEUAIActSettings} updateEUAIActSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEuAiActSettingsForProject: async (projectId: string, updateEUAIActSettings: UpdateEUAIActSettings, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('createEuAiActSettingsForProject', 'projectId', projectId)
            // verify required parameter 'updateEUAIActSettings' is not null or undefined
            assertParamExists('createEuAiActSettingsForProject', 'updateEUAIActSettings', updateEUAIActSettings)
            const localVarPath = `/projects/{project_id}/eu-ai-act/settings`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEUAIActSettings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Drop the stored EU AI Act answers. Does not apply the scope.
         * @summary Delete Eu Ai Act Settings For Project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEuAiActSettingsForProject: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('deleteEuAiActSettingsForProject', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/eu-ai-act/settings`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The question to answer now; none once the questionnaire is finished.
         * @summary Get Current Question
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentQuestion: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getCurrentQuestion', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/eu-ai-act/questionnaire/questions`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read the stored EU AI Act answers. A project that has none is a 404, not an empty payload.
         * @summary Get Eu Ai Act Settings For Project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEuAiActSettingsForProject: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getEuAiActSettingsForProject', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/eu-ai-act/settings`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A question with the answer given to it; a question not answered yet gives the current question.
         * @summary Get Question
         * @param {string} questionId 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestion: async (questionId: string, projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('getQuestion', 'questionId', questionId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getQuestion', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/eu-ai-act/questionnaire/questions/{question_id}`
                .replace('{question_id}', encodeURIComponent(String(questionId)))
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The EU AI Act scoping questionnaire with its tags so far and the requirements and controls they descope.
         * @summary Get Questionnaire
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionnaire: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getQuestionnaire', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/eu-ai-act/questionnaire`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Dry-run: compute the scope change-set without touching the DB.
         * @summary Preview Scope Controls And Requirements
         * @param {string} projectId 
         * @param {UpdateEUAIActSettings} updateEUAIActSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewScopeControlsAndRequirements: async (projectId: string, updateEUAIActSettings: UpdateEUAIActSettings, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('previewScopeControlsAndRequirements', 'projectId', projectId)
            // verify required parameter 'updateEUAIActSettings' is not null or undefined
            assertParamExists('previewScopeControlsAndRequirements', 'updateEUAIActSettings', updateEUAIActSettings)
            const localVarPath = `/projects/{project_id}/eu-ai-act/preview-scope`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEUAIActSettings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Commit the scope change-set: flip control/requirement statuses and write audit logs.
         * @summary Scope Controls And Requirements
         * @param {string} projectId 
         * @param {UpdateEUAIActSettings} updateEUAIActSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scopeControlsAndRequirements: async (projectId: string, updateEUAIActSettings: UpdateEUAIActSettings, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('scopeControlsAndRequirements', 'projectId', projectId)
            // verify required parameter 'updateEUAIActSettings' is not null or undefined
            assertParamExists('scopeControlsAndRequirements', 'updateEUAIActSettings', updateEUAIActSettings)
            const localVarPath = `/projects/{project_id}/eu-ai-act/scope`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEUAIActSettings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Edit the stored EU AI Act answers. Fields left out keep their values. Does not apply the scope.
         * @summary Update Eu Ai Act Settings For Project
         * @param {string} projectId 
         * @param {UpdateEUAIActSettings} updateEUAIActSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEuAiActSettingsForProject: async (projectId: string, updateEUAIActSettings: UpdateEUAIActSettings, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('updateEuAiActSettingsForProject', 'projectId', projectId)
            // verify required parameter 'updateEUAIActSettings' is not null or undefined
            assertParamExists('updateEuAiActSettingsForProject', 'updateEUAIActSettings', updateEUAIActSettings)
            const localVarPath = `/projects/{project_id}/eu-ai-act/settings`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEUAIActSettings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start, retake or confirm the questionnaire.  Confirming a completed questionnaire applies its result: its tags become the EU AI Act settings, the project\'s requirements and controls are scoped by them, and the answers are recorded as evidence on MCF-150.
         * @summary Update Questionnaire Status
         * @param {string} projectId 
         * @param {UpdateQuestionnaireStatusRequest} updateQuestionnaireStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestionnaireStatus: async (projectId: string, updateQuestionnaireStatusRequest: UpdateQuestionnaireStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('updateQuestionnaireStatus', 'projectId', projectId)
            // verify required parameter 'updateQuestionnaireStatusRequest' is not null or undefined
            assertParamExists('updateQuestionnaireStatus', 'updateQuestionnaireStatusRequest', updateQuestionnaireStatusRequest)
            const localVarPath = `/projects/{project_id}/eu-ai-act/questionnaire`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateQuestionnaireStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EuAiActApi - functional programming interface
 */
export const EuAiActApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EuAiActApiAxiosParamCreator(configuration)
    return {
        /**
         * Answer a question of this project\'s questionnaire and get the next step.  Answering a question again drops the answers given after it.
         * @summary Answer Question
         * @param {string} questionId 
         * @param {string} projectId 
         * @param {AnswerQuestionRequest} answerQuestionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async answerQuestion(questionId: string, projectId: string, answerQuestionRequest: AnswerQuestionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireStepResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.answerQuestion(questionId, projectId, answerQuestionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuAiActApi.answerQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Whether the project has a scoping questionnaire.  The cheap availability check behind the questionnaire button; it does not load the questionnaire.
         * @summary Check Questionnaire
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkQuestionnaire(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireExistsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkQuestionnaire(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuAiActApi.checkQuestionnaire']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Save the EU AI Act answers for the AI System, replacing any stored ones. Does not apply the scope.
         * @summary Create Eu Ai Act Settings For Project
         * @param {string} projectId 
         * @param {UpdateEUAIActSettings} updateEUAIActSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEuAiActSettingsForProject(projectId: string, updateEUAIActSettings: UpdateEUAIActSettings, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EUAIActSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEuAiActSettingsForProject(projectId, updateEUAIActSettings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuAiActApi.createEuAiActSettingsForProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Drop the stored EU AI Act answers. Does not apply the scope.
         * @summary Delete Eu Ai Act Settings For Project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEuAiActSettingsForProject(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEuAiActSettingsForProject(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuAiActApi.deleteEuAiActSettingsForProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The question to answer now; none once the questionnaire is finished.
         * @summary Get Current Question
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentQuestion(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireStepResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentQuestion(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuAiActApi.getCurrentQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read the stored EU AI Act answers. A project that has none is a 404, not an empty payload.
         * @summary Get Eu Ai Act Settings For Project
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEuAiActSettingsForProject(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EUAIActSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEuAiActSettingsForProject(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuAiActApi.getEuAiActSettingsForProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A question with the answer given to it; a question not answered yet gives the current question.
         * @summary Get Question
         * @param {string} questionId 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestion(questionId: string, projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireStepResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestion(questionId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuAiActApi.getQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The EU AI Act scoping questionnaire with its tags so far and the requirements and controls they descope.
         * @summary Get Questionnaire
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuestionnaire(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuestionnaire(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuAiActApi.getQuestionnaire']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Dry-run: compute the scope change-set without touching the DB.
         * @summary Preview Scope Controls And Requirements
         * @param {string} projectId 
         * @param {UpdateEUAIActSettings} updateEUAIActSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewScopeControlsAndRequirements(projectId: string, updateEUAIActSettings: UpdateEUAIActSettings, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScopePreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewScopeControlsAndRequirements(projectId, updateEUAIActSettings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuAiActApi.previewScopeControlsAndRequirements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Commit the scope change-set: flip control/requirement statuses and write audit logs.
         * @summary Scope Controls And Requirements
         * @param {string} projectId 
         * @param {UpdateEUAIActSettings} updateEUAIActSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scopeControlsAndRequirements(projectId: string, updateEUAIActSettings: UpdateEUAIActSettings, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scopeControlsAndRequirements(projectId, updateEUAIActSettings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuAiActApi.scopeControlsAndRequirements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Edit the stored EU AI Act answers. Fields left out keep their values. Does not apply the scope.
         * @summary Update Eu Ai Act Settings For Project
         * @param {string} projectId 
         * @param {UpdateEUAIActSettings} updateEUAIActSettings 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEuAiActSettingsForProject(projectId: string, updateEUAIActSettings: UpdateEUAIActSettings, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EUAIActSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEuAiActSettingsForProject(projectId, updateEUAIActSettings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuAiActApi.updateEuAiActSettingsForProject']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Start, retake or confirm the questionnaire.  Confirming a completed questionnaire applies its result: its tags become the EU AI Act settings, the project\'s requirements and controls are scoped by them, and the answers are recorded as evidence on MCF-150.
         * @summary Update Questionnaire Status
         * @param {string} projectId 
         * @param {UpdateQuestionnaireStatusRequest} updateQuestionnaireStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateQuestionnaireStatus(projectId: string, updateQuestionnaireStatusRequest: UpdateQuestionnaireStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateQuestionnaireStatus(projectId, updateQuestionnaireStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EuAiActApi.updateQuestionnaireStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EuAiActApi - factory interface
 */
export const EuAiActApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EuAiActApiFp(configuration)
    return {
        /**
         * Answer a question of this project\'s questionnaire and get the next step.  Answering a question again drops the answers given after it.
         * @summary Answer Question
         * @param {EuAiActApiAnswerQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerQuestion(requestParameters: EuAiActApiAnswerQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireStepResponse> {
            return localVarFp.answerQuestion(requestParameters.questionId, requestParameters.projectId, requestParameters.answerQuestionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Whether the project has a scoping questionnaire.  The cheap availability check behind the questionnaire button; it does not load the questionnaire.
         * @summary Check Questionnaire
         * @param {EuAiActApiCheckQuestionnaireRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkQuestionnaire(requestParameters: EuAiActApiCheckQuestionnaireRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireExistsResponse> {
            return localVarFp.checkQuestionnaire(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Save the EU AI Act answers for the AI System, replacing any stored ones. Does not apply the scope.
         * @summary Create Eu Ai Act Settings For Project
         * @param {EuAiActApiCreateEuAiActSettingsForProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEuAiActSettingsForProject(requestParameters: EuAiActApiCreateEuAiActSettingsForProjectRequest, options?: RawAxiosRequestConfig): AxiosPromise<EUAIActSettings> {
            return localVarFp.createEuAiActSettingsForProject(requestParameters.projectId, requestParameters.updateEUAIActSettings, options).then((request) => request(axios, basePath));
        },
        /**
         * Drop the stored EU AI Act answers. Does not apply the scope.
         * @summary Delete Eu Ai Act Settings For Project
         * @param {EuAiActApiDeleteEuAiActSettingsForProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEuAiActSettingsForProject(requestParameters: EuAiActApiDeleteEuAiActSettingsForProjectRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteEuAiActSettingsForProject(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * The question to answer now; none once the questionnaire is finished.
         * @summary Get Current Question
         * @param {EuAiActApiGetCurrentQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentQuestion(requestParameters: EuAiActApiGetCurrentQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireStepResponse> {
            return localVarFp.getCurrentQuestion(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read the stored EU AI Act answers. A project that has none is a 404, not an empty payload.
         * @summary Get Eu Ai Act Settings For Project
         * @param {EuAiActApiGetEuAiActSettingsForProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEuAiActSettingsForProject(requestParameters: EuAiActApiGetEuAiActSettingsForProjectRequest, options?: RawAxiosRequestConfig): AxiosPromise<EUAIActSettings> {
            return localVarFp.getEuAiActSettingsForProject(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * A question with the answer given to it; a question not answered yet gives the current question.
         * @summary Get Question
         * @param {EuAiActApiGetQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestion(requestParameters: EuAiActApiGetQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireStepResponse> {
            return localVarFp.getQuestion(requestParameters.questionId, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * The EU AI Act scoping questionnaire with its tags so far and the requirements and controls they descope.
         * @summary Get Questionnaire
         * @param {EuAiActApiGetQuestionnaireRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuestionnaire(requestParameters: EuAiActApiGetQuestionnaireRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireResponse> {
            return localVarFp.getQuestionnaire(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Dry-run: compute the scope change-set without touching the DB.
         * @summary Preview Scope Controls And Requirements
         * @param {EuAiActApiPreviewScopeControlsAndRequirementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewScopeControlsAndRequirements(requestParameters: EuAiActApiPreviewScopeControlsAndRequirementsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ScopePreview> {
            return localVarFp.previewScopeControlsAndRequirements(requestParameters.projectId, requestParameters.updateEUAIActSettings, options).then((request) => request(axios, basePath));
        },
        /**
         * Commit the scope change-set: flip control/requirement statuses and write audit logs.
         * @summary Scope Controls And Requirements
         * @param {EuAiActApiScopeControlsAndRequirementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scopeControlsAndRequirements(requestParameters: EuAiActApiScopeControlsAndRequirementsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.scopeControlsAndRequirements(requestParameters.projectId, requestParameters.updateEUAIActSettings, options).then((request) => request(axios, basePath));
        },
        /**
         * Edit the stored EU AI Act answers. Fields left out keep their values. Does not apply the scope.
         * @summary Update Eu Ai Act Settings For Project
         * @param {EuAiActApiUpdateEuAiActSettingsForProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEuAiActSettingsForProject(requestParameters: EuAiActApiUpdateEuAiActSettingsForProjectRequest, options?: RawAxiosRequestConfig): AxiosPromise<EUAIActSettings> {
            return localVarFp.updateEuAiActSettingsForProject(requestParameters.projectId, requestParameters.updateEUAIActSettings, options).then((request) => request(axios, basePath));
        },
        /**
         * Start, retake or confirm the questionnaire.  Confirming a completed questionnaire applies its result: its tags become the EU AI Act settings, the project\'s requirements and controls are scoped by them, and the answers are recorded as evidence on MCF-150.
         * @summary Update Questionnaire Status
         * @param {EuAiActApiUpdateQuestionnaireStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQuestionnaireStatus(requestParameters: EuAiActApiUpdateQuestionnaireStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireResponse> {
            return localVarFp.updateQuestionnaireStatus(requestParameters.projectId, requestParameters.updateQuestionnaireStatusRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for answerQuestion operation in EuAiActApi.
 */
export interface EuAiActApiAnswerQuestionRequest {
    readonly questionId: string

    readonly projectId: string

    readonly answerQuestionRequest: AnswerQuestionRequest
}

/**
 * Request parameters for checkQuestionnaire operation in EuAiActApi.
 */
export interface EuAiActApiCheckQuestionnaireRequest {
    readonly projectId: string
}

/**
 * Request parameters for createEuAiActSettingsForProject operation in EuAiActApi.
 */
export interface EuAiActApiCreateEuAiActSettingsForProjectRequest {
    readonly projectId: string

    readonly updateEUAIActSettings: UpdateEUAIActSettings
}

/**
 * Request parameters for deleteEuAiActSettingsForProject operation in EuAiActApi.
 */
export interface EuAiActApiDeleteEuAiActSettingsForProjectRequest {
    readonly projectId: string
}

/**
 * Request parameters for getCurrentQuestion operation in EuAiActApi.
 */
export interface EuAiActApiGetCurrentQuestionRequest {
    readonly projectId: string
}

/**
 * Request parameters for getEuAiActSettingsForProject operation in EuAiActApi.
 */
export interface EuAiActApiGetEuAiActSettingsForProjectRequest {
    readonly projectId: string
}

/**
 * Request parameters for getQuestion operation in EuAiActApi.
 */
export interface EuAiActApiGetQuestionRequest {
    readonly questionId: string

    readonly projectId: string
}

/**
 * Request parameters for getQuestionnaire operation in EuAiActApi.
 */
export interface EuAiActApiGetQuestionnaireRequest {
    readonly projectId: string
}

/**
 * Request parameters for previewScopeControlsAndRequirements operation in EuAiActApi.
 */
export interface EuAiActApiPreviewScopeControlsAndRequirementsRequest {
    readonly projectId: string

    readonly updateEUAIActSettings: UpdateEUAIActSettings
}

/**
 * Request parameters for scopeControlsAndRequirements operation in EuAiActApi.
 */
export interface EuAiActApiScopeControlsAndRequirementsRequest {
    readonly projectId: string

    readonly updateEUAIActSettings: UpdateEUAIActSettings
}

/**
 * Request parameters for updateEuAiActSettingsForProject operation in EuAiActApi.
 */
export interface EuAiActApiUpdateEuAiActSettingsForProjectRequest {
    readonly projectId: string

    readonly updateEUAIActSettings: UpdateEUAIActSettings
}

/**
 * Request parameters for updateQuestionnaireStatus operation in EuAiActApi.
 */
export interface EuAiActApiUpdateQuestionnaireStatusRequest {
    readonly projectId: string

    readonly updateQuestionnaireStatusRequest: UpdateQuestionnaireStatusRequest
}

/**
 * EuAiActApi - object-oriented interface
 */
export class EuAiActApi extends BaseAPI {
    /**
     * Answer a question of this project\'s questionnaire and get the next step.  Answering a question again drops the answers given after it.
     * @summary Answer Question
     * @param {EuAiActApiAnswerQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public answerQuestion(requestParameters: EuAiActApiAnswerQuestionRequest, options?: RawAxiosRequestConfig) {
        return EuAiActApiFp(this.configuration).answerQuestion(requestParameters.questionId, requestParameters.projectId, requestParameters.answerQuestionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Whether the project has a scoping questionnaire.  The cheap availability check behind the questionnaire button; it does not load the questionnaire.
     * @summary Check Questionnaire
     * @param {EuAiActApiCheckQuestionnaireRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checkQuestionnaire(requestParameters: EuAiActApiCheckQuestionnaireRequest, options?: RawAxiosRequestConfig) {
        return EuAiActApiFp(this.configuration).checkQuestionnaire(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Save the EU AI Act answers for the AI System, replacing any stored ones. Does not apply the scope.
     * @summary Create Eu Ai Act Settings For Project
     * @param {EuAiActApiCreateEuAiActSettingsForProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createEuAiActSettingsForProject(requestParameters: EuAiActApiCreateEuAiActSettingsForProjectRequest, options?: RawAxiosRequestConfig) {
        return EuAiActApiFp(this.configuration).createEuAiActSettingsForProject(requestParameters.projectId, requestParameters.updateEUAIActSettings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Drop the stored EU AI Act answers. Does not apply the scope.
     * @summary Delete Eu Ai Act Settings For Project
     * @param {EuAiActApiDeleteEuAiActSettingsForProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteEuAiActSettingsForProject(requestParameters: EuAiActApiDeleteEuAiActSettingsForProjectRequest, options?: RawAxiosRequestConfig) {
        return EuAiActApiFp(this.configuration).deleteEuAiActSettingsForProject(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The question to answer now; none once the questionnaire is finished.
     * @summary Get Current Question
     * @param {EuAiActApiGetCurrentQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCurrentQuestion(requestParameters: EuAiActApiGetCurrentQuestionRequest, options?: RawAxiosRequestConfig) {
        return EuAiActApiFp(this.configuration).getCurrentQuestion(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read the stored EU AI Act answers. A project that has none is a 404, not an empty payload.
     * @summary Get Eu Ai Act Settings For Project
     * @param {EuAiActApiGetEuAiActSettingsForProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getEuAiActSettingsForProject(requestParameters: EuAiActApiGetEuAiActSettingsForProjectRequest, options?: RawAxiosRequestConfig) {
        return EuAiActApiFp(this.configuration).getEuAiActSettingsForProject(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A question with the answer given to it; a question not answered yet gives the current question.
     * @summary Get Question
     * @param {EuAiActApiGetQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getQuestion(requestParameters: EuAiActApiGetQuestionRequest, options?: RawAxiosRequestConfig) {
        return EuAiActApiFp(this.configuration).getQuestion(requestParameters.questionId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The EU AI Act scoping questionnaire with its tags so far and the requirements and controls they descope.
     * @summary Get Questionnaire
     * @param {EuAiActApiGetQuestionnaireRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getQuestionnaire(requestParameters: EuAiActApiGetQuestionnaireRequest, options?: RawAxiosRequestConfig) {
        return EuAiActApiFp(this.configuration).getQuestionnaire(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Dry-run: compute the scope change-set without touching the DB.
     * @summary Preview Scope Controls And Requirements
     * @param {EuAiActApiPreviewScopeControlsAndRequirementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public previewScopeControlsAndRequirements(requestParameters: EuAiActApiPreviewScopeControlsAndRequirementsRequest, options?: RawAxiosRequestConfig) {
        return EuAiActApiFp(this.configuration).previewScopeControlsAndRequirements(requestParameters.projectId, requestParameters.updateEUAIActSettings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Commit the scope change-set: flip control/requirement statuses and write audit logs.
     * @summary Scope Controls And Requirements
     * @param {EuAiActApiScopeControlsAndRequirementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public scopeControlsAndRequirements(requestParameters: EuAiActApiScopeControlsAndRequirementsRequest, options?: RawAxiosRequestConfig) {
        return EuAiActApiFp(this.configuration).scopeControlsAndRequirements(requestParameters.projectId, requestParameters.updateEUAIActSettings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Edit the stored EU AI Act answers. Fields left out keep their values. Does not apply the scope.
     * @summary Update Eu Ai Act Settings For Project
     * @param {EuAiActApiUpdateEuAiActSettingsForProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateEuAiActSettingsForProject(requestParameters: EuAiActApiUpdateEuAiActSettingsForProjectRequest, options?: RawAxiosRequestConfig) {
        return EuAiActApiFp(this.configuration).updateEuAiActSettingsForProject(requestParameters.projectId, requestParameters.updateEUAIActSettings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Start, retake or confirm the questionnaire.  Confirming a completed questionnaire applies its result: its tags become the EU AI Act settings, the project\'s requirements and controls are scoped by them, and the answers are recorded as evidence on MCF-150.
     * @summary Update Questionnaire Status
     * @param {EuAiActApiUpdateQuestionnaireStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateQuestionnaireStatus(requestParameters: EuAiActApiUpdateQuestionnaireStatusRequest, options?: RawAxiosRequestConfig) {
        return EuAiActApiFp(this.configuration).updateQuestionnaireStatus(requestParameters.projectId, requestParameters.updateQuestionnaireStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

